<template>
    <div>
        <v-btn color="primary" id="signIn" @click="LoginFunction">Sign In</v-btn>
    </div>
</template>

<script>
import { userManager } from "../classes/cognitoAuth.mjs";

export default {
    name: 'CognitoLogin',
    data() {
        return {
        };
    },
    mounted() {
        // debug... console.log('Login component mounted!');
    },
    methods: {
        async LoginFunction() {
            // debug... 
            console.log('Login attempt started');

            await userManager.signinRedirect();

            // Note: results of sign in are handled in parent 
            // because response is async via page redirects
        },
    }
};
</script>

<style scoped></style>